import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_RecordReviewToolForProviders = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_RecordReviewToolForProviders' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <h3>Record Review Tool for Providers</h3>
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Client Name: </span></td>
                        <td className='w-250'><span className='eleHeader'> Case Manager:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date: </span></td>
                    </tr> 
                    <tr>
                        <td className='w-250'><input type='text' id='txtClient' name='txtClient' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtCase' name='txtCase' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'> <b>Intake</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'> The intake is completed within seven business days of the date of referral. </span>
                    <input type='radio' id='rbReviewToolYe_1' name='rbReviewTool_1' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_1' name='rbReviewTool_1' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_1' name='rbReviewTool_1' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_1' name='txtReviewToolComments_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Request for Prior Authorization is submitted to TMHP within three business days of the date of the intake. </span>
                    <input type='radio' id='rbReviewToolYe_2' name='rbReviewTool_2' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_2' name='rbReviewTool_2' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_2' name='rbReviewTool_2' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_2' name='txtReviewToolComments_2' className='add-only'></textarea>
                </p>


                <p className='w-750'> <b>Family Needs Assessment (FNA)</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'> FNA is completed within seven business days of prior authorization of service.</span>
                    <input type='radio' id='rbReviewToolYe_3' name='rbReviewTool_3' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_3' name='rbReviewTool_3' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_3' name='rbReviewTool_3' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_3' name='txtReviewToolComments_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> FNA reflects all needs documented on the Request for Prior Authorization.</span>
                    <input type='radio' id='rbReviewToolYe_4' name='rbReviewTool_4' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_4' name='rbReviewTool_4' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_4' name='rbReviewTool_4' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_4' name='txtReviewToolComments_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation in the FNA supports client eligibility. There must be a HEALTH CONDITION/RISK AND at least one medically necessary medical, social, educational, developmental or other need.</span>
                    <input type='radio' id='rbReviewToolYe_5' name='rbReviewTool_5' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_5' name='rbReviewTool_5' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_5' name='rbReviewTool_5' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_5' name='txtReviewToolComments_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>All fields in the FNA are addressed as evidenced by complete and appropriate documentation. </span>
                    <input type='radio' id='rbReviewToolYe_6' name='rbReviewTool_6' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_6' name='rbReviewTool_6' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_6' name='rbReviewTool_6' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_6' name='txtReviewToolComments_6' className='add-only'></textarea>
                </p>


                <p className='w-750'> <b>Service Plan (SP)</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation on the SP supports client eligibility. There must be at least one medically necessary medical, social, educational, developmental or other need.</span>
                    <input type='radio' id='rbReviewToolYe_7' name='rbReviewTool_7' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_7' name='rbReviewTool_7' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_7' name='rbReviewTool_7' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_7' name='txtReviewToolComments_7' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>SP is completed accurately; including documentation of all needs identified on the FNA, the interventions for addressing needs, the individual responsible for each action step and individualized time frames to address each action step. </span>
                    <input type='radio' id='rbReviewToolYe_8' name='rbReviewTool_8' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_8' name='rbReviewTool_8' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_8' name='rbReviewTool_8' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_8' name='txtReviewToolComments_8' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> SP consent form (CM-03CON) includes dated signature of client/parent/guardian.</span>
                    <input type='radio' id='rbReviewToolYe_9' name='rbReviewTool_9' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_9' name='rbReviewTool_9' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_9' name='rbReviewTool_9' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_9' name='txtReviewToolComments_9' className='add-only'></textarea>
                </p>


                <p className='w-750'> <b>Follow-Up Visits</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation includes evidence of eligibility.</span>
                    <input type='radio' id='rbReviewToolYe_10' name='rbReviewTool_10' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_10' name='rbReviewTool_10' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_10' name='rbReviewTool_10' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_10' name='txtReviewToolComments_10' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation on the first follow-up addresses all needs identified on the service plan.</span>
                    <input type='radio' id='rbReviewToolYe_11' name='rbReviewTool_11' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_11' name='rbReviewTool_11' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_11' name='rbReviewTool_11' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_11' name='txtReviewToolComments_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation in each follow-up includes efforts to REVIEW AND address ALL outstanding Service Plan needs.</span>
                    <input type='radio' id='rbReviewToolYe_12' name='rbReviewTool_12' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_12' name='rbReviewTool_12' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_12' name='rbReviewTool_12' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_12' name='txtReviewToolComments_12' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Timeframes are met, as documented by the Case Manager on the Service Plan and/or Follow-up visit. </span>
                    <input type='radio' id='rbReviewToolYe_13' name='rbReviewTool_13' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_13' name='rbReviewTool_13' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_13' name='rbReviewTool_13' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_13' name='txtReviewToolComments_13' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If applicable, the case manager requested prior authorization to conduct additional visits with the eligible client to address outstanding needs. </span>
                    <input type='radio' id='rbReviewToolYe_14' name='rbReviewTool_14' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_14' name='rbReviewTool_14' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_14' name='rbReviewTool_14' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_14' name='txtReviewToolComments_14' className='add-only'></textarea>
                </p>

                <p className='w-750'> <b>Required Documentation</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'>Required documentation is on HHSC standardized forms or agency forms approved by HHSC-CM. (Unless Managed Care Organization approved forms are used.) </span>
                    <input type='radio' id='rbReviewToolYe_15' name='rbReviewTool_15' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_15' name='rbReviewTool_15' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_15' name='rbReviewTool_15' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_15' name='txtReviewToolComments_15' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Documentation of activities, not otherwise documented on required forms, is recorded on progress notes.</span>
                    <input type='radio' id='rbReviewToolYe_16' name='rbReviewTool_16' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_16' name='rbReviewTool_16' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_16' name='rbReviewTool_16' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_16' name='txtReviewToolComments_16' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Required documentation includes the case manager's dated signature and license designation.</span>
                    <input type='radio' id='rbReviewToolYe_17' name='rbReviewTool_17' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_17' name='rbReviewTool_17' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_17' name='rbReviewTool_17' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_17' name='txtReviewToolComments_17' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Record includes required consents. </span>
                    <input type='radio' id='rbReviewToolYe_18' name='rbReviewTool_18' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_18' name='rbReviewTool_18' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_18' name='rbReviewTool_18' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_18' name='txtReviewToolComments_18' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any documents provided to the client/parent/guardian are written in the client's preferred language or signed by an interpreter. </span>
                    <input type='radio' id='rbReviewToolYe_19' name='rbReviewTool_19' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_19' name='rbReviewTool_19' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_19' name='rbReviewTool_19' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_19' name='txtReviewToolComments_19' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> When warranted, documentation indicates a report of abuse, neglect and/or exploitation of a child or person with a disability was made.</span>
                    <input type='radio' id='rbReviewToolYe_20' name='rbReviewTool_20' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_20' name='rbReviewTool_20' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_20' name='rbReviewTool_20' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_20' name='txtReviewToolComments_20' className='add-only'></textarea>
                </p>
                <p className='w-750'> <b>Billing Review</b> </p>
                <p className='w-750'>
                    <span className='eleHeader'> The records contained documentation for all contacts billed to Medicaid.</span>
                    <input type='radio' id='rbReviewToolYe_21' name='rbReviewTool_21' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_21' name='rbReviewTool_21' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_21' name='rbReviewTool_21' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_21' name='txtReviewToolComments_21' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> The case manager authorized for services matches the case manager who provided the services.</span>
                    <input type='radio' id='rbReviewToolYe_22' name='rbReviewTool_22' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReviewToolNo_22' name='rbReviewTool_22' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbReviewToolNA_22' name='rbReviewTool_22' className='add-only' value='NA' /> NA  
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtReviewToolComments_22' name='txtReviewToolComments_22' className='add-only'></textarea>
                </p> 



            </div>
        </form>

    )
}











